import React, { createContext, useContext } from 'react';
import { FourOhFourErrorPage } from '~app/components/Errors';
import GoToURL from '~app/components/Survey/GoToURL';
import { UseSurveyErrorsReturn } from './types';

const SurveyErrorsContext = createContext<UseSurveyErrorsReturn>({
  errors: [],
  errorGroups: {},
  hasNoErrors: true,
  hasVersionChanged: false,
  hasNotFoundErrors: false,
  hasValidationErrors: false,
  hasRedirectErrors: false,
  reset: () => {},
  setError: () => {},
  setErrors: () => {},
  setErrorsById: () => {},
  getErrorMetaByType: () => ({}),
  getErrorsByType: () => [],
  getErrorsById: () => [],
  removeErrorsByType: () => {},
  removeErrorsById: () => {},
  setMeta: () => {},
});

export function useSurveyErrorsContext(): UseSurveyErrorsReturn {
  return useContext(SurveyErrorsContext);
}

function SurveyErrorsProvider({
  children,
  ...api
}: { children: React.ReactNode } & UseSurveyErrorsReturn): React.ReactElement {
  if (api.hasNotFoundErrors) {
    return <FourOhFourErrorPage />;
  }
  if (api.hasRedirectErrors) {
    const { url } = api.getErrorMetaByType(api.errorGroups.redirect);
    // Should this show an interim page for redirection with this component?
    // or, if not, this could become a pure function.
    return <GoToURL url={url} />;
  }

  return (
    <SurveyErrorsContext.Provider value={api}>
      <>{children}</>
    </SurveyErrorsContext.Provider>
  );
}

export default SurveyErrorsProvider;
